export const CHAT = {
  W_MAX: 700,
  PX_INPUT: 26,
  W_AVATAR: 32,
  OFFSET_USER_AVATAR_DESKTOP: 32 + 16,
  OFFSET_ASSITANT_AVATAR_DESKTOP: 54 + 16,
  OFFSET_USER_AVATAR_MOBILE: 54 - 16 - 16,
};

export const FILE = {
  W_MAX: 361,
};
